import React from "react";

const ClassIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.273"
      height="22.998"
      viewBox="0 0 17.273 22.998"
    >
      <path
        id="Path_1334"
        data-name="Path 1334"
        d="M228.286,96h-15.3a.99.99,0,0,0-.987.987v21.024a.99.99,0,0,0,.987.987h15.3a.99.99,0,0,0,.987-.987V96.987A.99.99,0,0,0,228.286,96Zm-12.042,8.39h5.133v1.974h-5.133Zm9.278,7.205h-9.278v-1.974h9.278Z"
        transform="translate(-212 -96)"
        fill={fill}
      />
    </svg>
  );
};

export default ClassIcon;
